<template>
  <div id="featured-news">
    <h2 class="sr-only">Featured News</h2>
    <transition name="fade" mode="out-in">
      <div v-if="isLoading" key="loading" class="pc-featured">
        <div class="content">
          <div class="pc-cat"></div>
          <div class="pc-title"></div>
          <div class="pc-title" :style="{ width: '40%', marginBottom: '1rem' }"></div>
          <div class="pc-dots"></div>
        </div>
      </div>

      <swiper v-else ref="featuredNews" key="ready" :options="sliderOptions">
        <swiper-slide v-for="item in newsFeatured.items" :key="item.id">
          <article class="card card-featured-post">
            <a :href="item.url"
              :title="item.title"
              target="blank"
              rel="noopener noreferrer">
              <div class="card-content">
                <p class="post-category">Featured</p>
                <h3 v-html="item.title" class="post-title" />
              </div>
              <img
                :data-src="item.image"
                :alt="item.title"
                :title="item.title"
                class="post-image swiper-lazy"
                loading="lazy" />
            </a>
          </article>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </transition>
  </div>
</template>

<script>
import CommonMixin from '@/mixins/Common';

export default {
  name: 'FeaturedNews',

  mixins: [CommonMixin],

  data() {
    return {
      isLoading: false,
      cacheTime: 1800,
      limit: 5,
      sliderOptions: {
        autoplay: true,
        lazy: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },

  computed: {
    newsFeatured() {
      return this.$store.state.news.featured;
    },

    size() {
      return (this.isSmallScreen) ? 'medium' : 'full';
    },

    params() {
      return `?per_page=${this.limit}&_embed=1`;
    },

    options() {
      return {
        params: this.params,
        size: this.size,
      };
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      const now = this.$day().unix();
      const { items = [], timestamp = null } = this.newsFeatured;
      const isExpired = (now - timestamp) > this.cacheTime;
      if ((timestamp || items.length) && !isExpired) return;
      this.fetch();
    },

    async fetch() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('news/getFeatured', this.options);
        this.isLoading = false;
      } catch (err) {
        console.log('Featured news unavailable', err);
      }
    },
  },
};
</script>

<style lang="scss">
  #featured-news {
    .card-featured-post {
      position: relative;
      flex-direction: column;
      min-height: 27rem;
      z-index: 1;
      border: none;
      border-radius: 0;
      background-color: transparent;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      @include media ("<=tablet") {
        min-height: 20rem;
      }

      .card-content {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 1.5rem 2rem 4rem;
        background: rgba(0,0,0, 0.3);
        background: linear-gradient(0deg, rgba($black,0.95) 0%, rgba($black,0.5) 66.666%, rgba($black,0.01) 100%);

        @include media ("<=tablet") {
          padding: 1.25rem 1.25rem 3rem;
        }
      }

      .post-image {
        height: 27rem;
        width: 100%;
        object-fit: cover;
        border: none;

        @include media ("<=tablet") {
          height: 20rem;
        }
      }

      .post-category {
        display: inline-block;
        padding: 0.125rem 0.5rem;
        margin-bottom: 0.5rem;
        background-color: $color-primary;
        text-transform: uppercase;
        color: $black;
        font-size: 0.625rem;
        font-weight: 600;
      }

      .post-title {
        font-size: 1.5rem;
        color: $white;
        font-weight: 600;
        text-shadow: 1px 1px 3px rgba($black, 0.45);
      }

      .post-link {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 2;
      }
    }

    .pc-featured {
      position: relative;
      min-height: 27rem;
      background-color: rgba($white, 0.05);

      @include media ("<=tablet") {
        min-height: 20rem;
      }

      .content {
        position: absolute;
        left: 1.5rem;
        bottom: 1.5rem;
        width: calc(100% - 3rem);
        opacity: 0.4;

        > div {
          @include placeholder-animation;
          margin-bottom: 0.5rem;
        }
      }

      .pc-cat {
        height: 1rem;
        width: 6rem;
      }

      .pc-title {
        height: 1.5rem;
        width: 100%;
        background-color: #ccc;
      }

      .pc-dots {
        height: 1rem;
        width: 4rem;
      }
    }

    .swiper-pagination {
      text-align: left;
      left: 2rem;
      bottom: 1.5rem;

      @include media ("<=tablet") {
        left: 1.25rem;
        bottom: 1.25rem;
      }

      .swiper-pagination-bullet {
        background: $white;
        border-radius: 0.25rem;
        width: 0.5rem;
        transition: all 0.3s ease;

        &:hover {
          opacity: 1;
          background: $color-primary;
        }
      }

      .swiper-pagination-bullet-active {
        width: 2rem;
        background: $white;
      }
    }
  }
</style>
